import React from 'react';
import { Container, Col, Row } from 'reactstrap';
import './contact.css';
import map from './map.PNG';

import { Link } from 'react-scroll'

var Translate = require('react-translate-component')

export default class ContactDetails extends React.Component {
    render() {
        return (
            <Container className="jumbotronContactDetails">

                <Row className="contactDetailsRow">
                    <Col className="contactDetailsText" md="3" sm="12" xs="12">
                        <div>
                            <p className="title"><Translate content='menu' /></p>
                            <p></p>
                            <Link activeClass="customActive active" to="offers" spy={true} smooth={true} duration={500}offset={-89}>
                                <p><Translate content='oferta' /></p>
                            </Link>
                            <Link activeClass="customActive active" to="jumbotronAbout" spy={true} smooth={true} duration={500}offset={-89}>
                                <p><Translate content='o_nas' /></p>
                            </Link>
                            <Link activeClass="customActive active" to="projects" spy={true} smooth={true} duration={500}offset={-89}>
                                <p><Translate content='realizacje' /></p>
                            </Link>
                            <Link activeClass="customActive active" to="partners_content" spy={true} smooth={true} duration={500}offset={-89}>
                                <p><Translate content='zaufali_nam' /></p>
                            </Link>
                            <Link activeClass="customActive active" to="jumbotronContact" spy={true} smooth={true} duration={500}offset={-89}>
                                <p><Translate content='kontakt' /></p>
                            </Link>
                        </div>
                    </Col>

                    <Col className="contactDetailsText"  md="3" sm="12" xs="12">
                        <div>
                            <p className="title">Kontakt</p>
                            <p>Przedpole 1, Warszawa, Polska</p>
                            <p>+48 501 375 425</p>
                            <p>biuro@mtd.waw.pl</p>
                            <p>NIP 951-11-13-230</p>
                            <p>regon 012224173</p>
                        </div>
                    </Col>
                    <Col sm="12" md="6" xs="12">
                        <img id="contactMap" src={map} alt="map"></img>
                    </Col>
                </Row>
                <Row className="footer">
                    <p>© Copyright 2020 MTD All Rights Reserved</p>
                </Row>
            </Container>
        );
    };

}